import type {
  CarsListSuccess,
} from '@autobid/strapi-integration/typescript/auction/carsList'
import type { ItemDeleteEvent } from '@autobid/ui/types/websocket/ItemDeleteEvent'
import type { ItemWithdrawEvent } from '@autobid/ui/types/websocket/ItemWithdrawEvent'
import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import {
  auctionCarsQueryKey,
} from '@autobid/ui/composables/car/data/useAuctionCars'
import { AUCTION_CARS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAuctionCarsSocket'
import { randomDebounce } from '@autobid/ui/utils/randomDebounce'
import { useQueryClient } from '@tanstack/vue-query'

export function useAuctionCarsItemWithdrawOrDelete() {
  const { startListen } = useWebSocketStore()
  const queryClient = useQueryClient()

  const itemWithdrawOrDelete = () => {
    const callback = (event: ItemWithdrawEvent | ItemDeleteEvent) => {
      randomDebounce(0, 3000, () => {
        queryClient.invalidateQueries({
          predicate: (query) => {
            if (!Array.isArray(query.queryKey))
              return false

            const auctionCarsBaseQueryKey = auctionCarsQueryKey.all()
            if (query.queryKey[0] !== auctionCarsBaseQueryKey[0])
              return false

            const queryData = query.state
              .data as CarsListSuccess['data']['items']

            if (!queryData)
              return false

            return !!queryData.items.find(
              item => item.id === event.context.itemId,
            )
          },
        })
      })
    }

    startListen({
      eventName: 'premium.ITEM_WITHDRAW',
      callbackName: AUCTION_CARS_SOCKET_CALLBACK,
      callback: event => callback(event),
    })

    startListen({
      eventName: 'premium.ITEM_DELETED',
      callbackName: AUCTION_CARS_SOCKET_CALLBACK,
      callback: event => callback(event),
    })
  }

  return { itemWithdrawOrDelete }
}
